import deepmerge from 'deepmerge'
import { IntegrationServiceId } from '../../common/integrations'
import { ROUTER_BASEPATH } from '../../common/constants'
import { wealthboxSettingsDefaultValues, WealthboxSettingsFormValues } from './IntegrationManagement/IntegrationSpecificSettings/Wealthbox/models'
import { redtailSettingsDefaultValues, RedtailSettingsFormValues } from './IntegrationManagement/IntegrationSpecificSettings/Redtail/model'
import {
  blackDiamondSettingsDefaultValues,
  BlackDiamondSettingsFormValues,
  elementsSettingsDefaultValues,
  ElementsSettingsFormValues,
  practifiSettingsDefaultValues,
  PractifiSettingsFormValues,
  salesforceSettingsDefaultValues,
  SalesforceSettingsFormValues,
  xlr8SettingsDefaultValues,
  XLR8SettingsFormValues,
} from './IntegrationManagement/IntegrationSpecificSettings/SalesforceBased/models'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const merge = (x: { [key: string]: any }, y: { [key: string]: any }) =>
  deepmerge(x, y, {
    arrayMerge: (_, source) => source,
  })

export const getIntegrationEnableUrl = (accountId: string, serviceId: IntegrationServiceId, redirectUri: string, state: string, code?: string) => {
  const enableUrl = `${import.meta.env.REACT_APP_IAM_API_BASE_URL}/accounts/${accountId}/user-integrations/${serviceId}/enable?redirect_uri=${redirectUri}&state=${state}`
  return code ? `${enableUrl}&code=${code}` : enableUrl
}

export const getIntegrationRedirectUri = (serviceId: string) => {
  const redirectUrl = window.location.origin + ROUTER_BASEPATH + `/integrations/callback/${serviceId}`
  return encodeURIComponent(redirectUrl)
}

export type IntegrationSettingsFormValues =
  | WealthboxSettingsFormValues
  | RedtailSettingsFormValues
  | SalesforceSettingsFormValues
  | PractifiSettingsFormValues
  | XLR8SettingsFormValues
  | ElementsSettingsFormValues
  | BlackDiamondSettingsFormValues

export const getDefaultIntegrationSettingsFormValues = (serviceId: string): IntegrationSettingsFormValues => {
  if (serviceId === 'wealthbox') {
    return wealthboxSettingsDefaultValues
  } else if (serviceId === 'redtail') {
    return redtailSettingsDefaultValues
  } else if (serviceId === 'salesforce') {
    return salesforceSettingsDefaultValues
  } else if (serviceId === 'practifi') {
    return practifiSettingsDefaultValues
  } else if (serviceId === 'elements') {
    return elementsSettingsDefaultValues
  } else if (serviceId === 'blackdiamond') {
    return blackDiamondSettingsDefaultValues
  } else {
    return xlr8SettingsDefaultValues
  }
}
